export const whitelist = [
    'csv',
    'csvnumberupdate',
    'not-found',
    'guide',
    'guides',
    'services',
    'settings',
    'virtualuserguide',
    'managed-sites',
];

export const singleRoutesStyles = {
    '&.chakra-stack': {
        marginTop: 0,
        button: {
            padding: '4px',
            borderRadius: '0.375rem',
        },
        svg: {
            marginLeft: '4px',
        },
    },
};
